<a [href]="router.url.includes('#content') ? router.url : router.url + '#content'" tabindex="0" accesskey="s" class="visually-hidden skip-link">Skip to Main Content</a>

<ng-template #headerActions>
  <div class="header__toolbar">
    @if (authService.user | async) {
      <div class="header__actions">
        <app-draft-mode></app-draft-mode>
        <button mat-stroked-button color="accent" (click)="logout()">Logout</button>
      </div>
    }
    @if (devServer) {
      <span class="header__dev-badge">Dev</span>
    }
  </div>
</ng-template>

@if (ups.draftPrefs | async; as prefs) {
  <div
    class="header"
    role="banner"
    [ngStyle]="{
      height: headerHeight + 'px',
      'background-color': prefs?.headerColor,
      'background-image': (ups.headerBgImageCss | async),
      'border-bottom': prefs?.headerBottomBorderStyle,
    }"
  >
    <img class="header__logo" [ngStyle]="{
      'padding-top': headerHeight / 10 + 'px',
      'padding-bottom': headerHeight / 10 + 'px',
    }" [src]="(ups.logoURL | async) || 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='" [attr.alt]="prefs?.universityName ? prefs.universityName + ' School Logo' : 'School Logo'" />
    <ng-container *ngTemplateOutlet="headerActions" />
  </div>
} @else {
  <div
    class="header"
    role="banner"
    [ngStyle]="{
      height: headerHeight + 'px',
      background: 'linear-gradient(0deg, rgba(98,121,228,0.45) 0%, rgba(98,121,228,.8) 25%, rgba(98,121,228,1) 50%, rgba(98,121,228,1) 100%)',
    }"
  >
    <ng-container *ngTemplateOutlet="headerActions" />
  </div>
}
